import React, { useState, useEffect } from 'react';
import { apiService } from '../../utils/api';
import { FaUser, FaEnvelope, FaUserTag, FaCalendarAlt, FaCircle, FaEdit, FaSave, FaTimes } from 'react-icons/fa';
import './ProfileStyles.css';

function TeacherProfile({ user }) {
  const [isEditing, setIsEditing] = useState(true);
  const [formData, setFormData] = useState({
    username: user.username,
    email: user.email,
    password: '',
    confirmPassword: ''
  });
  const [message, setMessage] = useState({ type: '', text: '' });
  // const [stats, setStats] = useState({
  //   totalStudents: 0,
  //   totalDocuments: 0,
  //   totalBatches: 0
  // });

  // useEffect(() => {
  //   const fetchTeacherStats = async () => {
  //     try {
  //       const response = await apiService.getTeacherStats();
  //       if (response.data.success) {
  //         setStats(response.data.stats);
  //       }
  //     } catch (err) {
  //       console.error('Error fetching teacher stats:', err);
  //     }
  //   };

  //   fetchTeacherStats();
  // }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage({ type: '', text: '' });

    if (formData.password && formData.password !== formData.confirmPassword) {
      setMessage({ type: 'error', text: 'Passwords do not match' });
      return;
    }

    try {
      const updateData = {
        username: formData.username,
        email: formData.email
      };

      if (formData.password) {
        updateData.password = formData.password;
      }

      const response = await apiService.updateTeacherProfile(updateData);

      if (response.data.success) {
        setMessage({ type: 'success', text: 'Profile updated successfully' });
        // Update local storage with new user data
        const updatedUser = { ...user, ...updateData };
        delete updatedUser.password;
        localStorage.setItem('user', JSON.stringify(updatedUser));
        // setIsEditing(false);
      } else {
        setMessage({ type: 'error', text: response.data.message || 'Update failed' });
      }
    } catch (err) {
      setMessage({ 
        type: 'error', 
        text: err.response?.data?.message || 'Error updating profile' 
      });
      console.error(err);
    }
  };

  return (
    <div className="teacher-profile profile-section">
      <div className="profile-header">
        <div className="profile-title">
          <h2>Teacher Profile</h2>
          {/* <div className="profile-avatar">
            {user.username.charAt(0).toUpperCase()}
          </div> */}
        </div>
        {/* <button 
          className={`profile-button ${isEditing ? 'cancel-button' : 'edit-button'}`}
          onClick={() => setIsEditing(!isEditing)}
        >
          {isEditing ? (
            <>
              <FaTimes /> Cancel
            </>
          ) : (
            <>
              <FaEdit /> Edit Profile
            </>
          )}
        </button> */}
      </div>

      {message.text && (
        <div className={`message ${message.type}`}>
          {message.text}
        </div>
      )}

      <div className="profile-content">
        <div className="profile-main">
          {isEditing ? (
            <form onSubmit={handleSubmit} className="profile-form">
              <div className="form-group">
                <label>
                  <FaUser className="form-icon" />
                  Username:
                </label>
                <input
                  type="text"
                  name="username"
                  value={formData.username}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label>
                  <FaEnvelope className="form-icon" />
                  Email:
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <label>
                  <FaUserTag className="form-icon" />
                  New Password (leave blank to keep current):
                </label>
                <input
                  type="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label>
                  <FaUserTag className="form-icon" />
                  Confirm New Password:
                </label>
                <input
                  type="password"
                  name="confirmPassword"
                  value={formData.confirmPassword}
                  onChange={handleChange}
                />
              </div>
              <button type="submit" className="profile-button save-button">
                <FaSave /> Save Changes
              </button>
            </form>
          ) : (
            <div className="profile-info">
              <div className="info-group">
                <span className="label">
                  <FaUser className="info-icon" />
                  Username:
                </span>
                <span className="value">{user.username}</span>
              </div>
              <div className="info-group">
                <span className="label">
                  <FaEnvelope className="info-icon" />
                  Email:
                </span>
                <span className="value">{user.email}</span>
              </div>
              <div className="info-group">
                <span className="label">
                  <FaUserTag className="info-icon" />
                  Role:
                </span>
                <span className="value">Teacher</span>
              </div>
              <div className="info-group">
                <span className="label">
                  <FaCalendarAlt className="info-icon" />
                  Account Created:
                </span>
                <span className="value">{new Date(user.createdAt).toLocaleDateString()}</span>
              </div>
              <div className="info-group">
                <span className="label">
                  <FaCircle className={`status-icon status-${user.status || 'active'}`} />
                  Status:
                </span>
                <span className={`value status-${user.status || 'active'}`}>
                  {user.status === 'blocked' ? 'Blocked' : 'Active'}
                </span>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default TeacherProfile;